// extracted by mini-css-extract-plugin
module.exports = {"name":"TimeRegistration_name__1zR3N","description":"TimeRegistration_description__3hPSs"};